export const normalizeString = (value?: string | null): string => (value || '').trim().toLowerCase();

export const equalsNormalized = (valueA?: string | null, valueB?: string | null): boolean =>
    normalizeString(valueA) === normalizeString(valueB);
